import IconBase from "react-icon-base";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="iso-8859-1"?>
        <svg width="100%" height="100%" viewBox="0 0 494 281" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve">
          <g id="path857" transform="matrix(1,0,0,1,1.07421e-13,-3.02835)">
            <path d="M278.263,143.112C278.263,220.479 215.972,283.2 139.129,283.2C62.287,283.2 -0,220.498 -0,143.112C-0,65.726 62.291,3.028 139.129,3.028C215.967,3.028 278.263,65.745 278.263,143.112M430.894,143.112C430.894,215.943 399.746,274.98 361.328,274.98C322.909,274.98 291.761,215.924 291.761,143.112C291.761,70.299 322.909,11.244 361.328,11.244C399.746,11.244 430.894,70.299 430.894,143.112M493.323,143.112C493.323,208.365 482.367,261.26 468.855,261.26C455.343,261.26 444.387,208.346 444.387,143.112C444.387,77.877 455.343,24.964 468.86,24.964C482.376,24.964 493.323,77.863 493.323,143.112" style="fill-rule:nonzero;"/>
          </g>
        </svg>
`,
      }}
    />
  );
}
